import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

export interface OfferContext { companyId?: string; teamId?: string; brand: string; }
export interface CompanyOffer {
  id: string; vendorProductId: string; title: string; description: string; details: string;
  imageUrl: string; logoUrl: string; nextLabel: string; price: string; salePrice: string; priceSuffix: string;
  actions: { id: string; label: string }[];
}
export interface CompanyOfferSelection {
  mode: 'inherit' | 'none' | 'custom'; productIds: string[]; effectiveProductIds: string[] | null;
  candidates: { id: string; name: string; vendorName: string }[];
}

@Injectable({ providedIn: 'root' })
export class CompanyOffersService {
  constructor(private restangular: Restangular) {}
  private plain(): Restangular {
    return this.restangular.withConfig((config: any) => config.setPlainByDefault(true));
  }
  list(context: OfferContext): Promise<CompanyOffer[]> {
    return this.plain().one('company-offers').customGET('', context).toPromise();
  }
  launch(context: OfferContext, offerId: string, actionId: string): Promise<{ url: string }> {
    return this.plain().one('company-offers', offerId).one('actions', actionId).customGET('', context).toPromise();
  }
  getSelection(companyId: string): Promise<CompanyOfferSelection> {
    return this.plain().one('teams/companies', companyId).one('offers').get().toPromise();
  }
  saveSelection(companyId: string, selection: Pick<CompanyOfferSelection, 'mode' | 'productIds'>): Promise<CompanyOfferSelection> {
    return this.plain().one('teams/companies', companyId).one('offers').customPUT(selection).toPromise();
  }
}
